import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { NoteFormsSelect, NoteResourceFilter, noteFormModels } from './noteBulkFilters';

/**
 * Bulk note export — pick a note kind, optionally narrow it to specific forms
 * and one record, and get back a ZIP with one PDF per note in the date range.
 */
export const notesBulkExport = () => {
    return {
        title: 'Notes Bulk Export',
        url: '/reports/clinical/notes',
        list: [
            {
                type: 'select',
                name: 'formModel',
                label: 'Form Type',
                required: true,
                selectList: noteFormModels,
                renderValue: (option) => option?.name,
            },
            {
                type: 'customRow',
                renderRow: (control, watch, setValue) => (
                    <NoteFormsSelect control={control} watch={watch} setValue={setValue} />
                ),
            },
            {
                type: 'customRow',
                renderRow: (control, watch, setValue) => (
                    <NoteResourceFilter control={control} watch={watch} setValue={setValue} />
                ),
            },
            {
                type: 'dos',
                startDate: 'startDate',
                endDate: 'endDate',
                startLabel: 'Start Date',
                endLabel: 'End Date',
                required: true,
            },
        ],
    };
};

export const clinicalReportEnums = [
    {
        id: uuidv4(),
        name: 'Notes Bulk Export',
        description:
            'Downloads every note of a chosen form type in a date range as a ZIP of PDFs — clinical, claim, client, goal, invoice, office, payer, progress report, timesheet and staff notes.',
        generateInfo: notesBulkExport(),
    },
];
